import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { sessionService } from 'redux-react-session';
import {
  ROUTE_LOGIN,
} from 'constants/urls';

const Logout = ({
  setIsAuthenticated, resetContext, goHome, setSplashScreen, resetAll, logOut,
}) => {
  sessionService.deleteSession();
  sessionService.deleteUser();
  setIsAuthenticated(false);
  resetContext();
  goHome();
  setSplashScreen(true);
  resetAll();
  logOut();
  window.logout();
  return (
    <Redirect to={{
      pathname: ROUTE_LOGIN,
    }}
    />
  );
};

Logout.propTypes = {
  setIsAuthenticated: PropTypes.func.isRequired,
  resetContext: PropTypes.func.isRequired,
  goHome: PropTypes.func.isRequired,
  setSplashScreen: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
};

export default Logout;



// WEBPACK FOOTER //
// ./src/routes/Logout/components/Logout.jsx